const same = (a, b) => String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();

// The client record stores the primary contact in its own fields; the contact
// list is only used as a fallback when those fields are empty.
export function primaryContactIndex(client) {
  const contacts = Array.isArray(client?.contacts) ? client.contacts : [];
  const active = contacts.map((contact, index) => ({ contact, index })).filter(({ contact }) => contact && contact.active !== false);
  if (client?.contactEMail) {
    const byEmail = active.find(({ contact }) => same(contact.email, client.contactEMail));
    if (byEmail) return byEmail.index;
  }
  if (client?.contactLastname) {
    const byName = active.find(({ contact }) => same(contact.lastname, client.contactLastname) && same(contact.firstname, client.contactFirstname));
    return byName ? byName.index : -1;
  }
  if (client?.contactEMail) return -1;
  return active.length ? active[0].index : -1;
}

export function primaryContactFields(contact = {}) {
  return {
    contactFirstname: contact.firstname || "",
    contactLastname: contact.lastname || "",
    contactEMail: contact.email || "",
    contactPhone: contact.mobile || contact.phone || "",
  };
}
